<template>
  <div :class="$style.signUpContainer">
    <img :class="$style.signUpLogo" src="@/assets/images/linkooklive_longlogo.png" alt="Linkook logo" />
    <h2 :class="$style.signUpTitle">{{ contextTitle }}</h2>
    <p :class="$style.signUpDescription" v-html="contextDescription"></p>

    <!-- 카카오 로그인 버튼 -->
    <button :class="$style.loginButton" @click="singin">
      <img :class="$style.emailIcon" src="@/assets/images/kakao_fill.png" alt="kakao icon" />
      <span :class="$style.emailText">카카오로 계속하기</span>
    </button>

    <!-- 이메일 로그인 버튼 -->
    <button :class="[$style.loginButton, $style.emailButton]" @click="emailSignin">
      <img :class="$style.emailIcon" src="@/assets/images/mail.png" alt="email icon" />
      <span :class="$style.emailText">이메일로 계속하기</span>
    </button>

    <!-- 회원가입 유도 -->
    <div :class="$style.signupSection">
      <p :class="$style.signupPrompt">아직 링꾹라이브 회원이 아니신가요?</p>
      <button :class="$style.signupButton" @click="goToSignup">회원가입</button>
    </div>
  </div>
</template>
<script>
import { useUserStore } from "@/store/user";

export default {
  name: "SigninContent",
  emits: ["switchToSignup", "switchToEmailLogin"],
  computed: {
    userStore() {
      return useUserStore();
    },
    loginContext() {
      return this.userStore.loginContext || 'general';
    },
    contextTitle() {
      const titleMap = {
        liveLike: '공연을 찜하시려면 로그인이 필요해요',
        videoLike: '영상을 찜하시려면 로그인이 필요해요',
        artistLike: '아티스트를 찜하시려면 로그인이 필요해요',
        likeFilter: '찜 목록을 보시려면 로그인이 필요해요',
        liveRegister: '공연을 등록하시려면 로그인이 필요해요',
        artistRegister: '아티스트를 등록하시려면 로그인이 필요해요',
        communityRegister: '글을 작성하시려면 로그인이 필요해요',
        recommend: '게시글을 추천하시려면 로그인이 필요해요',
        report: '신고하시려면 로그인이 필요해요',
        comment: '댓글을 남기시려면 로그인이 필요해요',
        profile: '마이페이지를 이용하시려면 로그인이 필요해요',
        general: '안녕하세요! 링꾹입니다',
      };
      return titleMap[this.loginContext] || '안녕하세요! 링꾹입니다';
    },
    contextDescription() {
      const descMap = {
        liveLike: '로그인하시면 마음에 드는 공연을<br/>찜해두고 놓치지 않을 수 있어요',
        videoLike: '로그인하시면 마음에 드는 영상을<br/>찜해두고 나중에 다시 볼 수 있어요',
        artistLike: '로그인하시면 좋아하는 아티스트를<br/>찜하고 새 소식을 받아볼 수 있어요',
        likeFilter: '로그인하시면 찜한 공연과 아티스트를<br/>한눈에 모아볼 수 있어요',
        liveRegister: '로그인하시면 공연 정보를<br/>직접 등록하고 공유할 수 있어요',
        artistRegister: '로그인하시면 아티스트 정보를<br/>직접 등록하고 공유할 수 있어요',
        communityRegister: '로그인하시면 게시판에<br/>글을 작성할 수 있어요',
        recommend: '로그인하시면 마음에 드는 글에<br/>추천을 남길 수 있어요',
        report: '로그인하시면 부적절한 콘텐츠를<br/>신고할 수 있어요',
        comment: '로그인하시면 다른 팬들과<br/>소통하고 댓글을 남길 수 있어요',
        profile: '로그인하시면 찜한 공연, 아티스트 관리와<br/>프로필 설정을 할 수 있어요',
        general: '링꾹에서 다양한 라이브 정보를<br/>확인하고 공유해보세요',
      };
      return descMap[this.loginContext] || '링꾹에서 다양한 라이브 정보를<br/>확인하고 공유해보세요';
    },
  },
  methods: {
    singin() {
      window.Kakao.Auth.authorize({
        redirectUri: process.env.VUE_APP_BASE_URL + "/kakaoLogin",
        throughTalk: false, // desktop-friendly
        scope: 'profile_nickname,account_email',
      });
    },

    emailSignin() {
      // 이메일 로그인 폼으로 전환하는 이벤트 발생
      this.$emit("switchToEmailLogin");
    },

    goToSignup() {
      // 회원가입 폼으로 전환하는 이벤트 발생
      this.$emit("switchToSignup");
    },
    getUserInfo() {
      window.Kakao.API.request({
        url: "/v2/user/me",
        success: () => {
          // console.log("사용자 정보", res);
        },
        fail: (err) => {
          console.error("사용자 정보 가져오기 실패", err);
        },
      });
    },
  },
};
</script>
<style module>
.signUpContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.signUpLogo {
  width: 50%;
  min-width: 200px;
  margin: 0 0 16px 0;
}

.signUpTitle {
  text-align: center;
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  color: #333;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.signUpDescription {
  text-align: center;
  font-size: 0.85rem;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.signupSection {
  padding-top: 20px;
  text-align: center;
}

.signupPrompt {
  font-size: 0.8rem;
  color: #999;
  margin: 0 0 8px 0;
}

.signupButton {
  background: none;
  border: none;
  color: #66bdff;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: color 0.2s ease;
  text-decoration: underline;
}

.signupButton:hover {
  color: #ff6b9d;
}

.loginButton {
  height: 50px;
  background-color: #fee502;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  min-width: 300px;
}

.loginButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.loginButtonImg {
  height: 40px;
}

.emailButton {
  background: #fff;
  border: 1px solid #333;
  color: #333;
  margin-top: 15px;
}

.emailButton:hover {
  background: #e8e8e8;
  border-color: #bbb;
}

.emailIcon {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}

.emailText {
  font-size: 16px;
  font-weight: 500;
}

.comingSoonText {
  font-size: 0.7rem;
  color: #999;
  margin-top: 8px;
  text-align: center;
}


@media screen and (max-width: 400px) {
  .signUpLogo {
    width: 60%;
    min-width: 150px;
  }

  .signUpTitle {
    font-size: 1rem;
  }

  .signUpDescription {
    font-size: 0.8rem;
  }

  .loginButton {
    height: 46px;
    min-width: 250px;
  }

  .emailIcon {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }

  .emailText {
    font-size: 14px;
  }

  .signupSection {
    padding-top: 15px;
  }

  .signupPrompt {
    font-size: 0.75rem;
  }

  .signupButton {
    font-size: 0.8rem;
  }
}

@media screen and (max-width: 300px) {
  .signUpLogo {
    width: 70%;
    min-width: 120px;
  }

  .signUpTitle {
    font-size: 0.95rem;
  }

  .signUpDescription {
    font-size: 0.7rem;
  }

  .loginButton {
    height: 42px;
    min-width: 200px;
  }

  .emailIcon {
    height: 16px;
    width: 16px;
    margin-right: 6px;
  }

  .emailText {
    font-size: 13px;
  }

  .signupSection {
    padding-top: 12px;
  }

  .signupPrompt {
    font-size: 0.7rem;
  }

  .signupButton {
    font-size: 0.75rem;
  }
}
</style>
